<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { ref } from 'vue'
import { ShareNetwork } from 'vue3-social-sharing'

const props = defineProps<{
  url: string
  title: string
  description: string
  media?: string
}>()

const toast = useToast()

const { copy } = useClipboard()

function copyUrl() {
  copy(props.url)
  toast.add({
    title: 'URL copiée!',
    color: 'success',
    icon: 'i-lucide-check-circle',
  })
}
</script>

<template>
  <div class="w-full flex justify-between">
    <ShareNetwork
      v-slot="{ share }"
      network="facebook"
      :url="props.url"
      :title="props.title"
      :description="props.description"
    >
      <UIcon name="i-mdi-facebook" class="size-8 cursor-pointer" style="color:#1877f2" @click="share" />
    </ShareNetwork>
    <ShareNetwork
      v-slot="{ share }"
      network="messenger"
      :url="props.url"
      :title="props.title"
      :description="props.description"
    >
      <UIcon name="i-mdi-facebook-messenger" class="size-8 cursor-pointer" style="color:#3b5998" @click="share" />
    </ShareNetwork>
    <ShareNetwork
      v-slot="{ share }"
      network="pinterest"
      :url="props.url"
      :title="props.title"
      :description="props.description"
      :media="props.media"
    >
      <UIcon name="i-mdi-pinterest" class="size-8 cursor-pointer" style="color:#bd081c" @click="share" />
    </ShareNetwork>
    <ShareNetwork
      v-slot="{ share }"
      network="email"
      :url="props.url"
      :title="props.title"
      :description="props.description"
    >
      <UIcon name="i-mdi-email" class="size-8 cursor-pointer" style="color:#ff9900" @click="share" />
    </ShareNetwork>
    <UIcon name="i-mdi-link-box-variant" class="size-8 cursor-pointer" style="color:#798da8" @click="copyUrl" />
  </div>
</template>
